<template>
  <div
    class="multiselect panel-select"
    :class="{
      'multiselect--active': isOpen,
      'multiselect--disabled': disabled,
      'multiselect--single': true
    }"
    ref="root"
    @keydown.stop.prevent="onKeydown"
  >
    <div class="multiselect__tags" @click="toggle">
      <span v-if="value" class="multiselect__single">
       
        <span class="fp-label">{{ currentLabel }}</span>
      </span>
      <input
        class="multiselect__input"
        type="text"
        :placeholder="!value ? $t('itemmodal.select_fire_protection') : ''"
        :readonly="true"
        :disabled="disabled"
        tabindex="-1"
      />
    </div>

    <div class="multiselect__select" @click="toggle" />

    <transition name="multiselect">
      <div v-show="isOpen" class="multiselect__content-wrapper" style="max-height: 240px;">
        <ul class="multiselect__content" role="listbox">
          <li v-for="opt in wrappedOptions" :key="opt.uid" class="multiselect__element" role="option">
            <span
              class="multiselect__option"
              :class="{
                'multiselect__option--selected': isSelected(opt.item),
                'multiselect__option--highlight': isSelected(opt.item) && isOpen
              }"
              @click="choose(opt.item)"
            >
              <span class="fp-label">{{ opt.label }}</span>
            </span>
          </li>

          <li v-if="wrappedOptions.length === 0" class="multiselect__element">
            <span class="multiselect__option multiselect__option--disabled">
              {{ $t('itemmodal.no_results') }}
            </span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import iconMixin from '@/mixins/iconMixin.js';

export default {
  name: 'TypeDropdownMultiselectSkin',
  mixins: [iconMixin],
  props: {
    value: { required: false }, // v-model (original item)
    items: { type: Array, required: true },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { isOpen: false };
  },
  computed: {
    currentLabel() {
      return this.value ? this.displayFPTitle(this.value) : this.$t('itemmodal.select_fire_protection');
    },
    currentIcon() {
      const key = this.resolveKey(this.value);
      return key ? this.getType(key).icon : null;
    },
    wrappedOptions() {
      return this.items
        .map((it, idx) => {
          const key = this.resolveKey(it);
          return {
            item: it,
            uid: this.buildUid(it, key, idx),
            label: this.displayFPTitle(it),
            icon: this.getType(key).icon
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label));
    }
  },
  methods: {
    toggle() { if (!this.disabled) this.isOpen = !this.isOpen; },
    close() { this.isOpen = false; },
    choose(item) {
      this.$emit('input', item);
      this.$emit('change', item);
      this.close();
    },
    isSelected(item) {
      const a = item && (item.fireProtection || item);
      const b = this.value && (this.value.fireProtection || this.value);
      return a && b && (a.id != null && b.id != null ? a.id === b.id : a === b);
    },
    resolveKey(it) {
      const fp = it && (it.fireProtection || it);
      const candidate =
        (typeof it === 'string' && it) ||
        fp?.inventoryType ||
        it?.key ||
        '';
      return this.normalizeTypeBare(candidate);
    },
    buildUid(it, key, idx) {
      const fp = it && (it.fireProtection || it);
      if (fp && fp.id != null) return `id:${fp.id}`;
      if (fp && fp.uid != null) return `uid:${fp.uid}`;
      if (it && it.key) return `key:${it.key}`;
      if (typeof it === 'string') return `s:${this.normalizeTypeBare(it)}`;
      return `i:${key}:${idx}`;
    },
    onKeydown(e) {
      if (this.disabled) return;
      if (e.key === ' ' || e.key === 'Enter') this.toggle();
      if (e.key === 'Escape') this.close();
    }
  },
  mounted() {
    this._onDoc = (e) => { if (!this.$el.contains(e.target)) this.close(); };
    document.addEventListener('click', this._onDoc);
  },
  beforeDestroy() {
    document.removeEventListener('click', this._onDoc);
  }
};
</script>

<style scoped>

.multiselect__option,
.multiselect__single { display: inline-flex; align-items: center; gap: .35rem; }

.fp-icon { width: 1.1em; height: 1.1em; display: inline-block; }

.multiselect.panel-select .multiselect__option {
  width: 100%;
}

.multiselect__input[readonly] { background: transparent; border: 0; padding: 0; height: 0; width: 0; }
</style>
